import { Component, Inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog"
import { MatButtonModule } from "@angular/material/button"
import { StationDeletionAssociatedData } from "../../../services/station.service"

export interface ForceDeleteStationDialogData {
  stationName: string
  associatedData: StationDeletionAssociatedData
}

@Component({
  selector: "app-force-delete-station-dialog",
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule],
  templateUrl: "./force-delete-station-dialog.component.html",
  styleUrl: "./force-delete-station-dialog.component.css",
})
export class ForceDeleteStationDialogComponent {
  confirmName = ""

  constructor(
    private ref: MatDialogRef<ForceDeleteStationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: ForceDeleteStationDialogData,
  ) {}

  get canConfirm(): boolean {
    return this.confirmName.trim() === this.data.stationName
  }

  get items(): { label: string; count: number }[] {
    const d = this.data.associatedData || {}
    return [
      { label: "station rates", count: d.rates_count ?? 0 },
      { label: "station clocks", count: d.clocks_count ?? 0 },
      { label: "schedule lockouts", count: d.lockouts_count ?? 0 },
      { label: "order rules", count: d.order_rules_count ?? 0 },
      { label: "station role assignments (users themselves are NOT deleted)", count: d.station_users_count ?? 0 },
      { label: "ratings records", count: d.ratings_count ?? 0 },
      { label: "recording approvals", count: d.recording_approvals_count ?? 0 },
    ]
  }

  cancel(): void {
    this.ref.close(false)
  }

  confirm(): void {
    if (!this.canConfirm) return
    this.ref.close(true)
  }
}
